import { IWildernessAreaBLMAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';
import { AdvisoryBlockIcon } from '../../components/icons/Icons.tsx';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties.ts';
import { AdvisoryLink } from './AdvisoryLink.tsx';

export const WildernessAreaBLMAdvisory = (props: ICompositeAdvisoryProperties<IWildernessAreaBLMAdvisoryProperties>) => {
    const distinctNames = Array.from(new Set(props.advisories.map(a => a.NLCS_NAME)));
    return (
        <SecondaryWarningAdvisory header="Wilderness Area" advisoryType={props.advisoryType} GLOBAL_ID={props.advisories[0].GLOBAL_ID} icon={AdvisoryBlockIcon} iconColor='danger'>
            <p>
                Your mission overlaps <strong>{distinctNames.join(', ')}</strong>. Check with the Bureau of Land Management prior to flight.
            </p>
            <p>
                The remote pilot in command must assess the local airspace along with any other takeoff, landing, and flight restrictions.
            </p>
            <p>
                <AdvisoryLink
                    text="Drones in Wilderness"
                    articleKey="DRONES_IN_WILDERNESS"
                />
            </p>
        </SecondaryWarningAdvisory>
    );
};
